export const PROFILE_PAGE_PATHNAME = "/profile";

export const HEADER_METRIC_NAMES = {
  LOGO_CLICK: "sb-header--logo-click",
  LOGOUT_CLICK: "sb-header--logout-click",
  PROFILE_CLICK: "sb-header--profile-click",
  NOTIFICATIONS_CLICK: "sb-header--notifications-click",
};

export const NOTIFICATIONS_POPUP_TRANSITION_DURATION = 500;
